import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowLeft, Building2, Scale, Shield } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { LogoIcon } from '../components/Logo';

const LegalMentions = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 to-white">
      {/* Header */}
      <div className="bg-white border-b">
        <div className="max-w-4xl mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <Button variant="ghost" size="sm" onClick={() => navigate(-1)}>
                <ArrowLeft className="w-5 h-5" />
              </Button>
              <LogoIcon size={8} />
              <span className="font-bold text-xl text-purple-700">Spirify</span>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-12">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Scale className="w-6 h-6 text-purple-600" />
              {t.legal?.title || 'Mentions légales'}
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-8">
            {/* Éditeur */}
            <section>
              <h3 className="text-lg font-semibold flex items-center gap-2 mb-3">
                <Building2 className="w-5 h-5 text-purple-600" />
                {t.legal?.editor || 'Éditeur du site'}
              </h3>
              <div className="bg-gray-50 p-4 rounded-lg space-y-1">
                <p className="font-semibold">MFP Services France</p>
                <p>3 rue des Tanneurs</p>
                <p>13100 Aix-en-Provence, France</p>
                <p className="mt-2">Email : contact@spirify.ai</p>
              </div>
            </section>

            {/* Hébergement */}
            <section>
              <h3 className="text-lg font-semibold flex items-center gap-2 mb-3">
                <Shield className="w-5 h-5 text-purple-600" />
                {t.legal?.hosting || 'Hébergement'}
              </h3>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="font-semibold">Hostinger</p>
                <p>https://www.hostinger.fr</p>
              </div>
            </section>

            {/* Propriété intellectuelle */}
            <section>
              <h3 className="text-lg font-semibold mb-3">
                {t.legal?.intellectualProperty || 'Propriété intellectuelle'}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {t.legal?.intellectualPropertyText || "L'ensemble de ce site relève de la législation française et internationale sur le droit d'auteur et la propriété intellectuelle. Tous les droits de reproduction sont réservés, y compris pour les documents téléchargeables et les représentations iconographiques et photographiques."}
              </p>
            </section>

            {/* Données personnelles */}
            <section>
              <h3 className="text-lg font-semibold mb-3">
                {t.legal?.personalData || 'Données personnelles'}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-4">
                {t.legal?.personalDataText || "Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification et de suppression des données vous concernant. Pour exercer ce droit, contactez-nous à l'adresse : contact@spirify.ai"}
              </p>
            </section>

            {/* Cookies */}
            <section>
              <h3 className="text-lg font-semibold mb-3">
                {t.legal?.cookies || 'Cookies'}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {t.legal?.cookiesText || "Ce site utilise des cookies pour améliorer l'expérience utilisateur et réaliser des statistiques de visites. En continuant à naviguer sur ce site, vous acceptez l'utilisation de cookies."}
              </p>
            </section>

            {/* Responsabilité */}
            <section>
              <h3 className="text-lg font-semibold mb-3">
                {t.legal?.liability || 'Responsabilité'}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {t.legal?.liabilityText || "Les informations fournies sur ce site le sont à titre informatif. MFP Services ne saurait garantir l'exactitude, la complétude ou l'actualité des informations diffusées sur le site."}
              </p>
            </section>

            {/* Date de mise à jour */}
            <div className="text-center text-sm text-gray-500 pt-4 border-t">
              {t.legal?.lastUpdate || 'Dernière mise à jour'} : {new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' })}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default LegalMentions;
